'use client'

import { GATEWAY_ACTIVE_STATE_TEST_IDS } from '@modules/gateways/gateways-test-ids.const'

import type { GatewayActiveStateProps } from './GatewayActiveState.types'
import { GatewayActiveStateVariant } from './GatewayActiveState.types'

import styles from './GatewayActiveState.module.scss'

const indicatorClassByVariant = {
  [GatewayActiveStateVariant.Healthy]: styles.indicatorHealthy,
  [GatewayActiveStateVariant.Offline]: styles.indicatorOffline,
  [GatewayActiveStateVariant.Degraded]: styles.indicatorDegraded,
  [GatewayActiveStateVariant.Unhealthy]: styles.indicatorUnhealthy,
  [GatewayActiveStateVariant.Started]: styles.indicatorStarted,
} as const

export function GatewayActiveState({ className, label, variant }: GatewayActiveStateProps) {
  const rootClass = [styles.root, variant === GatewayActiveStateVariant.Offline && styles.rootOffline, className]
    .filter(Boolean)
    .join(' ')

  return (
    <span className={rootClass} data-testid={GATEWAY_ACTIVE_STATE_TEST_IDS.root}>
      <span className={`${styles.indicator} ${indicatorClassByVariant[variant]}`} aria-hidden="true" />
      <span className={styles.label}>{label}</span>
    </span>
  )
}
